






import Vue from 'vue'

import { IArticle } from '../store/state'
import Article from './Article.vue'
import { EventBus } from '../helpers/EventBus.vue' 

interface NewsListComputed {
	news: IArticle[],
}

interface NewsListMethods {
	focusFirst(): void
}

export default Vue.extend<{}, NewsListMethods, NewsListComputed, {}>({
	name: 'NewsList',
	mounted() {
		EventBus.$on('focusFirst', () => this.focusFirst());
	},
	computed: {
		news() {
			return this.$store.getters.news
		}
	},
	components: {
		Article
	},
	methods: {
		focusFirst() {
			const list = this.$refs.list as HTMLElement;
			const first = list.querySelector('a');
			first?.focus();
		}
	}
})
